import { useState, useEffect } from 'react';

import LoadStatus from 'config/load_status';

import mostRatedRecipes from 'domain/recipe/usecases/most_rated_recipes';

import delayed from 'utils/delayed';

const useMostRatedRecipes = () => {
  const [recipes, setRecipes] = useState([]);
  const [mostRatedRecipesLoadStatus, setMostRatedRecipesLoadStatus] = useState(
    LoadStatus.LOADING
  );

  useEffect(() => {
    if (mostRatedRecipesLoadStatus !== LoadStatus.LOADING) return;

    const readData = async () => {
      try {
        const newRecipes = await delayed(mostRatedRecipes(), 25);

        setRecipes(newRecipes);
        setMostRatedRecipesLoadStatus(LoadStatus.DONE);
      } catch (error) {
        setMostRatedRecipesLoadStatus(LoadStatus.ERROR);
        throw error;
      }
    };
    readData();
  }, [mostRatedRecipesLoadStatus]);

  const loadMoreRecipes = () => {
    if (mostRatedRecipesLoadStatus === LoadStatus.LOADING) return;
    setMostRatedRecipesLoadStatus(LoadStatus.LOADING);
  };

  return {
    loadMoreRecipes,
    recipes,
    hasFailed: mostRatedRecipesLoadStatus === LoadStatus.ERROR,
    hasFinished: mostRatedRecipesLoadStatus === LoadStatus.DONE,
    isLoading: mostRatedRecipesLoadStatus === LoadStatus.LOADING,
  };
};

export default useMostRatedRecipes;
